import * as Sentry from '@sentry/react'
import axios from 'axios'

import {
  ApiErrorCodes,
  ClientError,
  ErrorResponse,
} from '@tribeplatform/gql-client'
import { GraphqlClient } from '@tribeplatform/gql-client/client'
import { AuthToken } from '@tribeplatform/gql-client/types'

import { AppInitialProps } from '../@types/app.types'

// This will hold a loading state for different errors to make sure we are not pursuing the same error multiple times
const ErrorHandlingLoadingStates = {}

const handleInvalidAccessToken = async (
  errors: ErrorResponse[],
  client: GraphqlClient,
  pageProps: AppInitialProps,
) => {
  try {
    const isInvalidToken =
      Array.isArray(errors) &&
      errors?.some(e => e.code === ApiErrorCodes.INVALID_ACCESS_TOKEN)

    if (
      isInvalidToken &&
      !ErrorHandlingLoadingStates[ApiErrorCodes.INVALID_ACCESS_TOKEN]
    ) {
      ErrorHandlingLoadingStates[ApiErrorCodes.INVALID_ACCESS_TOKEN] = true
      const networkDomain =
        pageProps?.authToken?.network?.domain ||
        pageProps?.authToken?.networkPublicInfo?.domain
      if (!networkDomain) {
        Sentry.captureException(
          'networkDomain is not defined on global error handler',
        )
      }
      const response = await axios.post<AuthToken>('/api/auth/refresh-token', {
        networkDomain,
      })

      if (response?.data) {
        client.setToken(response.data.accessToken)
      }
      ErrorHandlingLoadingStates[ApiErrorCodes.INVALID_ACCESS_TOKEN] = false
    }
  } catch (e) {
    ErrorHandlingLoadingStates[ApiErrorCodes.INVALID_ACCESS_TOKEN] = false
    Sentry.captureException(e)
    console.warn('Could not update the access token on global error handler', e)
  }
}
export const onClientError =
  (pageProps: AppInitialProps) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (errors: ErrorResponse[], client: GraphqlClient, error?: ClientError) => {
    handleInvalidAccessToken(errors, client, pageProps)
  }
